import * as React from 'react';

interface WorkspaceSidebarContextValue {
  analyticsCustomizerOpen: boolean;
  openAnalyticsCustomizer: () => void;
  closeAnalyticsCustomizer: () => void;
}

const WorkspaceSidebarContext = React.createContext<WorkspaceSidebarContextValue | null>(null);

export const WorkspaceSidebarProvider = WorkspaceSidebarContext.Provider;

export function useWorkspaceSidebar(): WorkspaceSidebarContextValue {
  const value = React.useContext(WorkspaceSidebarContext);
  if (!value) throw new Error('useWorkspaceSidebar must be used inside AuthLayout');
  return value;
}
